<template>
    <div class="step-upload">
        <div class="img-picker">
            <ImgPicker
                ref="imgPicker"
                :editable="true"
                :extensions="extensionsAllowed"
                :acceptExtension="'.jpg, .png, .jpeg'"
                title=""
                hidePreview
                addImageToList
                isCatalogo
                :qtdImagesAdd="images.length"
                @uploadedFiles="getFiles"
                @filesRemoved="showImagesRemovedMessage"
                @maxImageAdd="showMessageMaxLimitAdd"
            />
        </div>
    </div>
</template>

<script>
import ImgPicker from '@/components/shared/form/ImgPicker.vue';

export default {
    props: {
        images: {
            type: Array,
            default: () => [],
        },
    },
    components: {
        ImgPicker,
    },
    data() {
        return {
            extensionsAllowed: ['jpg', 'png', 'jpeg'],
        };
    },
    created() {
        this.permissao = this.hasPermissionAccess('vendas', 'produtos', 'ven-produto-catalogo');

        !this.permissao.read &&
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'catalogo' },
            });
    },
    methods: {
        getFiles(files) {
            this.images.push(...files);
            this.$emit('uploadedFiles', this.images);
        },
        showImagesRemovedMessage(numOfImages) {
            let qtdDimensao = numOfImages.qtdDimensao;
            let qtdExtensao = numOfImages.qtdExtensao;
            let qtdSize = numOfImages.qtdSize;
            let qtdErasedByLimit = numOfImages.qtdErasedByLimit;

            if (qtdDimensao > 0 || qtdExtensao > 0 || qtdSize > 0 || qtdErasedByLimit > 0) {
                let message = '';
                if (qtdDimensao > 0) {
                    message +=
                        this.$t('msg-catalogo-imagens-maiores-dimensao-maxima-n', {
                            n: qtdDimensao,
                        }) + '<br>';
                }

                if (qtdExtensao > 0) {
                    message +=
                        this.$t('msg-catalogo-imagens-extensao-nao-permitida-n', {
                            n: qtdExtensao,
                        }) + '<br>';
                }

                if (qtdSize > 0) {
                    message +=
                        this.$t('msg-catalogo-imagens-tamanho-nao-permitido-n', { n: qtdSize }) +
                        '<br>';
                }

                if (qtdErasedByLimit > 0) {
                    message += this.$t('msg-catalogo-imagens-removido-limit-n', {
                        n: qtdErasedByLimit,
                    });
                }

                this.$root.alert({
                    message: message,
                });
            }
        },
        showMessageMaxLimitAdd() {
            let message = this.$t('msg-catalogo-imagens-maximo-adicionado');

            this.$root.alert({
                message: message,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.step-upload {
    display: flex;
    width: 100%;
    min-height: 650px;
    justify-content: space-between;
    padding: 10px;

    .img-picker {
        width: 100%;
    }
}
</style>
